// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/unblock_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/unblock_account.proto.
 */
export const file_accounts_unblock_account: GenFile = /*@__PURE__*/
  fileDesc("Ch5hY2NvdW50cy91bmJsb2NrX2FjY291bnQucHJvdG8SD3Byb3Rvcy5hY2NvdW50cyJ0ChVVbmJsb2NrQWNjb3VudFJlcXVlc3QSPQoGcGFyYW1zGAEgASgLMi0ucHJvdG9zLmFjY291bnRzLlVuYmxvY2tBY2NvdW50UmVxdWVzdC5QYXJhbXMaHAoGUGFyYW1zEhIKCmFjY291bnRfaWQYASABKAkiYgoWVW5ibG9ja0FjY291bnRSZXNwb25zZRI+CgZyZXN1bHQYASABKAsyLi5wcm90b3MuYWNjb3VudHMuVW5ibG9ja0FjY291bnRSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.accounts.UnblockAccountRequest
 */
export type UnblockAccountRequest = Message<"protos.accounts.UnblockAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.UnblockAccountRequest.Params params = 1;
   */
  params?: UnblockAccountRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.UnblockAccountRequest.
 * Use `create(UnblockAccountRequestSchema)` to create a new message.
 */
export const UnblockAccountRequestSchema: GenMessage<UnblockAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_unblock_account, 0);

/**
 * @generated from message protos.accounts.UnblockAccountRequest.Params
 */
export type UnblockAccountRequest_Params = Message<"protos.accounts.UnblockAccountRequest.Params"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.accounts.UnblockAccountRequest.Params.
 * Use `create(UnblockAccountRequest_ParamsSchema)` to create a new message.
 */
export const UnblockAccountRequest_ParamsSchema: GenMessage<UnblockAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_unblock_account, 0, 0);

/**
 * @generated from message protos.accounts.UnblockAccountResponse
 */
export type UnblockAccountResponse = Message<"protos.accounts.UnblockAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.UnblockAccountResponse.Result result = 1;
   */
  result?: UnblockAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.UnblockAccountResponse.
 * Use `create(UnblockAccountResponseSchema)` to create a new message.
 */
export const UnblockAccountResponseSchema: GenMessage<UnblockAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_unblock_account, 1);

/**
 * @generated from message protos.accounts.UnblockAccountResponse.Result
 */
export type UnblockAccountResponse_Result = Message<"protos.accounts.UnblockAccountResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.UnblockAccountResponse.Result.
 * Use `create(UnblockAccountResponse_ResultSchema)` to create a new message.
 */
export const UnblockAccountResponse_ResultSchema: GenMessage<UnblockAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_unblock_account, 1, 0);

